<template>
    <li class="pt-12 relative pl-6 md:pl-12 flex justify-content-between items-center">

        <span class="absolute flex justify-center items-center w-8 h-8 rounded-full shadow-lg bg-white border-2"
              :class="[isDraftOrNew ? 'border-brand text-brand' : 'border-blue-400 text-blue-400']"
              style="top: 50%; left: -17px">
            <icon-mail class="w-5 h-5"></icon-mail>
        </span>

        <div class="flex justify-between items-start flex-grow-1">
            <div class="">
                <h4 class="flex items-center font-medium"><span>{{ getActivityTitle() }}</span>
                    <icon-message-failed class="ml-2 w-4 h-4 text-brand inline" v-if="isFailedEmail"></icon-message-failed>
                    <icon-check class="ml-2 w-4 h-4 text-green-400 inline" v-if="!isFailedEmail & !isReceivedMail"></icon-check>
                </h4>
                <p class="text-gray-500 font-normal text-sm">
                    {{ activity.source.preview }}
                </p>
                <div class="p-1">
                    <button type="button"
                            @click="viewEmail"
                            class="inline-flex items-center mr-1 -ml-1.5 px-1.5 py-0.5 border border-transparent text-xs leading-4 font-medium rounded text-indigo-600 bg-indigo-100 hover:text-indigo-800 hover:bg-indigo-50 focus:outline-none focus:border-indigo-300 focus:shadow-outline-indigo active:bg-indigo-200 transition ease-in-out duration-300">
                        View Email
                    </button>
                </div>
            </div>
            <div v-if="activity.source && activity.source.sent_status !== 'draft'" class="pl-4 text-gray-400 text-xs min-w-100 leading-tight">
                <div class="text-right whitespace-nowrap">{{ (activity.source.sent_at ? activity.source.sent_at : activity.source.created_at) | date }}</div>
                <div class="text-right"><span>{{ (activity.source.sent_at ? activity.source.sent_at : activity.source.created_at) | timeonly }}</span></div>
            </div>
        </div>
    </li>
</template>


<script>
import CommonProps from "../../../mixins/activity-common-mixin";

export default {

    mixins: [CommonProps],

    data () {
        return {
            email: this.activity.source
        };
    },

    created () {
        let self = this;
        if (this.email.sent_status === "new" || this.email.sent_status === "draft") {
            Bus.$on("email-updated", function (email) {
                if (self.email.id === email.id) {
                    self.email = email;
                }
            });
        }
    },

    computed: {
        isFailedEmail () {
            return this.email && ((this.email.sent_status !== null && this.email.sent_status.includes("failed")) || this.hasFailedEvent);
        },

        hasFailedEvent () {
            return this.email && this.email.failed_event != null;
        },

        failedEventPreview () {
            if (this.hasFailedEvent && this.email.failed_event.reason !== null) {
                return this.email.failed_event.reason.length <= 20 ? this.email.failed_event.reason : this.email.failed_event.reason.substring(0, 17) + "...";
            }
            return "Email could not be delivered";
        },

        isSentMail () {
            return this.email && this.email.type === "sent";
        },

        isReceivedMail () {
            return this.email && this.email.type === "received";
        },

        isDraftOrNew () {
            return this.email && (this.email.sent_status === "new" || this.email.sent_status === "draft" ? "draft-email-activity" : "");
        },
    },

    methods: {
        getActivityTitle () {

            if (this.isReceivedMail) {
                return this.receivedEmailTitle();
            }

            if (this.isSentMail) {
                return this.sentEmailTitle();
            }

        },

        receivedEmailTitle () {

            return "Email received from " + (this.email.from_name ? this.email.from_name : this.email.from);

        },

        sentEmailTitle () {

            if (this.email.sent_status === "new") {
                if (_.includes(this.email.subject, "Job card")) {
                    return "Draft job card email";
                }
                return "Draft email";
            }

            if (this.email.sent_status === "draft") {

                if (_.includes(this.email.subject, "job card")) {
                    return "Draft job card email";
                }

                if (_.includes(this.email.subject, "task card")) {
                    return "Draft task card email";
                }

                if (_.isEmpty(this.email.to_name, this.email.to)) {
                    return "Draft email";
                }
                return "Draft email to " + (this.email.to_name ? this.email.to_name : this.email.to);
            }

            if (_.includes(this.email.subject, "Job card")) {
                return "Job card sent to " + (this.email.to_name ? this.email.to_name : this.email.to);
            }

            if (_.includes(this.email.subject, "Task Card")) {
                return "Task Card sent to " + (this.email.to_name ? this.email.to_name : this.email.to);
            }

            return "Email sent to " + (this.email.to_name ? this.email.to_name : this.email.to);

        },

        viewEmail () {
            const url = `/attachments/multi/ticket/${this.activity.ticket_id}`;
            this.$store.dispatch("UPDATE_FILE_SELECTION_URL_FOR_CONTEXT", url);
            this.$emit("view-email", this.email.thread_id);
        }

    }

};

</script>

<style scoped>
.activity-icon.failed {
    background-color: #b11623;
    color: #FFF;
}

div.failed {
    font-weight: 500;
    color: #b11623;
}

span.failed {
    background-color: #b11623;
    color: #FFF;
    padding: 3px 10px;
    margin-left: 10px;
    vertical-align: text-top;
}
</style>
